/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RateDescriptionType {
    LineHaul = 76,
    Accessorial = 65,
    Flat = 70,
    Fuel = 85,
    Tax = 84,
    Exchange = 69,
}
